export const searchTypeConfig = {
  username: {
    icon: '👤',
    title: 'Enter Username',
    description: 'Search across 100+ platforms and social networks',
    placeholder: 'Enter username...',
    examples: ['github', 'elonmusk', 'openai', 'microsoft']
  },
  email: {
    icon: '📧',
    title: 'Enter Email Address',
    description: 'Verify email and check data breaches',
    placeholder: 'example@domain.com',
    examples: ['test@gmail.com', 'user@example.com']
  },
  phone: {
    icon: '📞',
    title: 'Enter Phone Number',
    description: 'Global carrier info and spam check',
    placeholder: '+1234567890',
    examples: ['+14155552671', '+447911123456']
  },
  domain: {
    icon: '🌐',
    title: 'Enter Domain Name',
    description: 'WHOIS lookup and DNS analysis',
    placeholder: 'example.com',
    examples: ['google.com', 'github.com', 'twitter.com']
  },
  image: {
    icon: '🖼️',
    title: 'Image Investigation',
    description: 'Reverse search, metadata extraction, and forensic analysis',
    placeholder: 'Paste image URL or describe the image...',
    examples: ['https://example.com/image.jpg', 'photo of landmark']
  },
  social: {
    icon: '📱',
    title: 'Social Network Deep Dive',
    description: 'Platform-specific investigation and monitoring tools',
    placeholder: 'Enter profile URL or username...',
    examples: ['@username', 'https://twitter.com/user']
  },
  ai_report: {
    icon: '🧠',
    title: 'AI Web Intelligence',
    description: 'Search the web and generate a structured AI summary report',
    placeholder: 'Enter search query, company, or person name...',
    examples: ['OpenAI recent news', 'John Doe CEO', 'Cybersecurity 2026']
  }
};
